
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/layout/TabBar';

const allServices = [
  {
    id: 1,
    name: 'تمريض منزلي',
    description: 'رعاية طبية متخصصة في منزلك',
    icon: 'ri-nurse-line',
    color: 'from-[#1565C0] to-[#1976D2]',
    rating: 4.8,
    reviews: 245,
    price: '200',
    image: 'https://public.readdy.ai/ai/img_res/0218b70ddcc676a710bca46bd8a5503a.jpg'
  },
  {
    id: 2,
    name: 'تنظيف شامل',
    description: 'تنظيف عميق لجميع أركان المنزل',
    icon: 'ri-brush-line',
    color: 'from-[#2E7D32] to-[#43A047]',
    rating: 4.9,
    reviews: 312,
    price: '150',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20worker%20in%20uniform%20cleaning%20modern%20home%20interior%2C%20cleaning%20supplies%20and%20equipment%2C%20bright%20clean%20space%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20fresh%20atmosphere&width=400&height=300&seq=cleaning2&orientation=landscape'
  },
  {
    id: 3,
    name: 'سباكة',
    description: 'إصلاح وصيانة جميع أعمال السباكة',
    icon: 'ri-drop-line',
    color: 'from-[#0277BD] to-[#0288D1]',
    rating: 4.7,
    reviews: 189,
    price: '180',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20fixing%20pipes%20and%20faucets%20in%20modern%20bathroom%2C%20plumbing%20tools%20visible%2C%20clean%20workspace%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=300&seq=plumbing2&orientation=landscape'
  },
  {
    id: 4,
    name: 'كهرباء',
    description: 'أعمال كهربائية آمنة واحترافية',
    icon: 'ri-flashlight-line',
    color: 'from-[#F57C00] to-[#FB8C00]',
    rating: 4.8,
    reviews: 201,
    price: '160',
    image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20working%20on%20electrical%20panel%20and%20wiring%20in%20modern%20home%2C%20electrical%20tools%20and%20equipment%2C%20safety%20gear%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=300&seq=electrical2&orientation=landscape'
  },
  {
    id: 5,
    name: 'صيانة مكيفات',
    description: 'تنظيف وصيانة أجهزة التكييف',
    icon: 'ri-temp-cold-line',
    color: 'from-[#00838F] to-[#0097A7]',
    rating: 4.9,
    reviews: 278,
    price: '200',
    image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20servicing%20air%20conditioning%20unit%20in%20modern%20home%2C%20AC%20maintenance%20tools%2C%20clean%20workspace%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20expert%20service&width=400&height=300&seq=ac1&orientation=landscape'
  },
  {
    id: 6,
    name: 'صيانة غسالات',
    description: 'إصلاح جميع أنواع الغسالات',
    icon: 'ri-contrast-drop-line',
    color: 'from-[#6A1B9A] to-[#7B1FA2]',
    rating: 4.6,
    reviews: 156,
    price: '170',
    image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20washing%20machine%20in%20modern%20home%2C%20repair%20tools%20visible%2C%20clean%20workspace%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20expert%20service&width=400&height=300&seq=washer1&orientation=landscape'
  },
  {
    id: 7,
    name: 'كشف تسربات',
    description: 'كشف وإصلاح تسربات المياه',
    icon: 'ri-water-flash-line',
    color: 'from-[#0277BD] to-[#0288D1]',
    rating: 4.8,
    reviews: 167,
    price: '180',
    image: 'https://readdy.ai/api/search-image?query=Professional%20leak%20detection%20specialist%20using%20modern%20equipment%20to%20find%20water%20leaks%20in%20home%2C%20detection%20tools%20visible%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=300&seq=leak1&orientation=landscape'
  },
  {
    id: 8,
    name: 'تركيب ثريات',
    description: 'تركيب وصيانة الإنارة',
    icon: 'ri-lightbulb-line',
    color: 'from-[#F57C00] to-[#FB8C00]',
    rating: 4.7,
    reviews: 134,
    price: '120',
    image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20installing%20modern%20chandelier%20in%20elegant%20home%20interior%2C%20electrical%20tools%20visible%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20expert%20installation&width=400&height=300&seq=chandelier1&orientation=landscape'
  }
];

const categories = [
  { id: 'all', name: 'الكل', icon: 'ri-apps-line' },
  { id: 'nursing', name: 'تمريض', icon: 'ri-nurse-line' },
  { id: 'cleaning', name: 'تنظيف', icon: 'ri-brush-line' },
  { id: 'plumbing', name: 'سباكة', icon: 'ri-drop-line' },
  { id: 'electrical', name: 'كهرباء', icon: 'ri-flashlight-line' },
  { id: 'maintenance', name: 'صيانة', icon: 'ri-tools-line' }
];

export default function Services() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6">
        <div className="flex items-center gap-3 mb-4 animate-fadeIn">
          <button onClick={() => navigate('/home')} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <h1 className="text-xl font-bold text-white">جميع الخدمات</h1>
        </div>

        {/* Search */}
        <div className="bg-white rounded-2xl p-3 flex items-center gap-3 shadow-md animate-slideUp">
          <i className="ri-search-line text-gray-400 text-xl"></i>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="ابحث عن خدمة..."
            className="flex-1 outline-none text-sm text-[#212121]"
          />
        </div>
      </div>

      {/* Categories */}
      <div className="px-6 mt-4">
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl whitespace-nowrap transition-all ${
                selectedCategory === category.id
                  ? 'bg-[#1565C0] text-white shadow-md'
                  : 'bg-white text-gray-600'
              }`}
            >
              <i className={`${category.icon} text-sm`}></i>
              <span className="text-sm font-semibold">{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Services List */}
      <div className="px-6 mt-6 pb-4" data-product-shop>
        <div className="space-y-4">
          {allServices.map((service, index) => (
            <div
              key={service.id}
              onClick={() => navigate(`/service/${service.id}`)}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all active:scale-[0.98] animate-slideUp cursor-pointer"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="flex gap-3 p-3">
                <div className="relative w-24 h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src={service.image}
                    alt={service.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-20`}></div>
                </div>
                
                <div className="flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="font-bold text-[#212121] text-sm mb-1">{service.name}</h3>
                    <p className="text-gray-500 text-xs mb-2">{service.description}</p>
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-[#FBC02D] text-xs"></i>
                        <span className="text-xs font-semibold text-[#212121]">{service.rating}</span>
                      </div>
                      <span className="text-gray-400 text-xs">({service.reviews})</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center gap-1">
                      <span className="text-[#1565C0] font-bold text-sm">{service.price}</span>
                      <span className="text-gray-400 text-xs">ر.س</span>
                    </div>
                    <button className="bg-[#1565C0] text-white px-3 py-1.5 rounded-lg text-xs font-semibold">
                      احجز
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TabBar />
    </div>
  );
}
